import { render, staticRenderFns } from "./ConfirmUserPage.vue?vue&type=template&id=6266c89a&scoped=true"
import script from "./ConfirmUserPage.vue?vue&type=script&lang=ts"
export * from "./ConfirmUserPage.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmUserPage.vue?vue&type=style&index=0&id=6266c89a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6266c89a",
  null
  
)

export default component.exports